<table width="100%">
  <tr
    *ngFor="let mark of marks"
    [ngClass]="{
      timebar: mark.marshal === 999,
      joker: +mark.joker > 0,
      obligatory: +mark.obligatory === 0,
      manualEdit: mark.manualEdit.length > 0,
      gray: !mark.time && mark.obligatory === 1
    }"
  >
    <td width="35px" *ngIf="!TVResume">{{ mark.marshal === 999 ? appSettings.translate[appSettings.selectedLang]['timebar'] : mark.marshal }}</td>
    <td *ngIf="!TVResume">
      <span *ngIf="!mark.time && mark.obligatory === 1"> - -:- -:- - </span>
      <span *ngIf="mark.time && time_state === 1">{{ mark.time | date : timeFormat : selectedRace.offset }}</span>
      <span *ngIf="mark.time && time_state === 2">{{ mark.delta | timePeriodPipe : timeFormat }}</span>
      <span *ngIf="mark.time && time_state === 3">{{ mark.deltaLap | timePeriodPipe : timeFormat }}</span>
      <span *ngIf="mark.time && time_state === 4">{{ mark.deltaStart | timePeriodPipe : timeFormat }}</span>
      <span *ngIf="mark.time && time_state === 5">{{ mark.deltaLeader | timePeriodPipe : timeFormat }}</span>
    </td>
  </tr>
  <tr>
    <td colspan="2" style="text-align: right">
      <b *ngIf="competitor.laps[col.lap].time">{{ competitor.laps[col.lap].time | timePeriodPipe : timeFormat }}</b>
    </td>
  </tr>
</table>